import Script from 'next/script';

const GoogleAnalytics = () => {
    const GA_MEASUREMENT_ID = 'G-G1DV0E2EMT'; // Updated measurement ID

    return (
        <>
            <Script
                src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
                strategy="afterInteractive"
                async
            />
            <Script
                id="google-analytics-script"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${GA_MEASUREMENT_ID}', {
                          page_path: window.location.pathname,
                          send_page_view: true
                        });
                        
                        // Debug helper to verify GA is working
                        console.log("Google Analytics initialized with ID: ${GA_MEASUREMENT_ID}");
                    `.replace('${GA_MEASUREMENT_ID}', GA_MEASUREMENT_ID) + `
                        
                        // Helper function to easily track events
                        window.trackEvent = function(eventName, eventParams) {
                            if (window.gtag) {
                                window.gtag('event', eventName, eventParams);
                                console.log("Event tracked:", eventName, eventParams);
                            } else {
                                console.error("Google Analytics not loaded - could not track event:", eventName);
                            }
                        };
                    `
                }}
            />
        </>
    );
};

export default GoogleAnalytics;
